import React from 'react';
import { GettonciniIcon } from '../icons';
import styles from '../styles/GettonciniCostChip.module.css';

const toPositiveIntegerOrNull = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  const rounded = Math.trunc(parsed);
  return rounded > 0 ? rounded : null;
};

const GettonciniCostChip = ({ amount, free = false, direction = 'spend', compact = false, className = '' }) => {
  const resolvedAmount = toPositiveIntegerOrNull(amount);
  if (!free && resolvedAmount == null) {
    return null;
  }

  const classes = [styles.chip, compact ? styles.compact : '', className]
    .filter(Boolean)
    .join(' ');

  if (free) {
    return <span className={classes} aria-label="Aiutino gratuito"><span className={styles.amount}>Gratis</span></span>;
  }

  const amountLabel = `${direction === 'earn' ? '+' : '-'}${resolvedAmount.toLocaleString('it-IT')}`;
  const actionText = direction === 'earn' ? 'Ricompensa' : 'Costo';

  return (
    <span
      className={classes}
      aria-label={`${actionText} ${amountLabel} gettoncini`}
      title={`${actionText} ${amountLabel} gettoncini`}
    >
      <span className={styles.amount}>{amountLabel}</span>
      <span className={styles.icon} aria-hidden="true">
        <GettonciniIcon size={compact ? 14 : 16} />
      </span>
    </span>
  );
};

export default GettonciniCostChip;
